import PageLayout from "../components/UI/Layout/PageLayout";
import Dashboard from "../components/Dashboard/Dashboard";
import GuidedTour from "../components/GuidedTour/GuidedTour";
import {
  PRO_DASHBOARD_GUIDE_ID,
  PRO_DASHBOARD_GUIDE_STEPS,
} from "../components/GuidedTour/guides";
import useAuth from "../hooks/use-auth.js";

function DashboardPage() {
  const { isPro } = useAuth();
  return (
    <PageLayout isBailleur>
      {isPro && (
        <GuidedTour
          guideId={PRO_DASHBOARD_GUIDE_ID}
          steps={PRO_DASHBOARD_GUIDE_STEPS}
        />
      )}
      <Dashboard />
    </PageLayout>
  );
}

export default DashboardPage;
